<template>
	<div class="bc">
		<div class="forget">
			<!-- 管理设置 -->
			<el-form :model="formData" ref="form" :rules="rules" label-width="100px" class="demo-ruleForm" width="500px">
				<el-form-item>
					<p style="color: #606266;">这里设置的是本单位指定的平台管理员基本信息</p>
				</el-form-item>
				<el-form-item label="姓名" prop="userName">
					<el-input type="text" disabled v-model="formData.userName" clearable></el-input>
				</el-form-item>
				<el-form-item label="电话" prop="phonenumber">
					<el-input type="text" disabled v-model="formData.phonenumber" clearable maxlength="11"></el-input>
				</el-form-item>
				<el-form-item label="角色" prop="roleName">
					<el-input type="text" disabled v-model="formData.roleName" clearable></el-input>
				</el-form-item>
				<el-form-item label="部门" prop="deptName">
					<el-input type="text" disabled v-model="formData.deptName" clearable></el-input>
				</el-form-item>
				<el-form-item label="岗位" prop="postName">
					<el-input type="text" disabled v-model="formData.postName" clearable></el-input>
				</el-form-item>
				<el-form-item label="LOGO" v-show="roleId==3?true:false">
					<el-upload class="avatar-uploader" action="/api/admin/user/uploadAvatar" :show-file-list="false" :on-success="handleAvatarSuccess"
					 :headers="headerData" name="file" :before-upload="beforeAvatarUpload">
						<img v-if="formData.previewPath" :src="formData.previewPath" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						<div class="el-upload__tip" slot="tip">只能上传jpg/png/jpeg文件，且不超过2MB</div>
					</el-upload>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="back">返回</el-button>
					<!-- <el-button type="primary" @click="submitForm()" style="margin-left: 60px;">修改信息</el-button> -->
				</el-form-item>
			</el-form>

		</div>
	</div>
</template>

<script>
	import {
		phoneRules
	} from '../views/apartment/verify.js';
	export default {
		data() {
			return {
				formData: {
					name: null,
					phone: null,
					duties: null, //职务
					dept: null, //部门
					job: null, //岗位
					avatarPath: null, //头像路径
					previewPath: null, //预览路径
				},

				imageUrl: "",
				roleId: sessionStorage.getItem('roleId') * 1,
				// 请求头携带token
				headerData: {
					Authorization: localStorage.access_token
				},
				rules: {
					name: [{
							required: true,
							message: '请输入姓名',
							trigger: ["blur", "change"]
						},
						// {
						// 	min: 2,
						// 	max: 5,
						// 	message: '姓名在2 到 5 个字',
						// 	trigger: 'change'
						// }
					],
					phone: [{
							validator: phoneRules,
							trigger: ["blur", "change"]
						},
						{
							required: true,
							message: "电话号码不能为空",
							trigger: ["blur", "change"]
						}
					]
				},

			};
		},
		mounted() {
			this.$http.post("/api/user/findInfo").then(res => {
				console.log(res);
				this.formData = res.data.data;
			})
		},
		methods: {
			submitForm() {
				this.$refs.form.validate((valid) => {
					console.log(valid);
					if (valid) {
						this.editPersonalInfor();
					} else {
						this.$message.error("请填写正确信息")
						return false;
					}
				});
			},
			// 编辑个人信息
			editPersonalInfor() {
				this.$http.post(`/api/user/editUser`, {
					...this.formData,
					id: sessionStorage.getItem("createId"),
				}).then(res => {
					if (res.data.code == 0) {
						this.$message.success(res.data.message);
						sessionStorage.setItem("name", this.formData.name);
						this.back();
					}
					if (res.data.code == -1) {
						this.$message.error(res.data.message)
					}
					if (res.data.code == 500) {
						this.$message.error("信息不匹配,修改失败")
					}
				})
			},
			back() {
				this.$router.go(-1)
			},
			// 上传之前
			beforeAvatarUpload(file) {
				console.log(file);
				var isJPG = null;
				if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg') {
					isJPG = true;
				} else {
					isJPG = false;
				}
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
					this.$message.error('上传Logo只能是 JPG/JPEG/PNG 格式!');
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isLt2M && isJPG;
			},

			// 上传成功
			handleAvatarSuccess(file) {
				console.log(file);
				this.formData.avatarPath = file.data.avatarPath;
				this.formData.previewPath = file.data.previewPath;
				console.log(this.formData);
			},

		}
	}
</script>

<style scoped="scoped">
	.bc {
		padding-top: 200px;
		width: 100%;
		height: 100%;
		background-image: url(../assets/imgs/bg.jpg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: left top;
	}

	.forget {
		width: 30%;
		margin: 0 auto;
		margin-top: -100px;
		background-color: #fafafa;
		padding: 60px 60px 40px 60px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}


	>>>.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	>>>.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>
